import React from 'react';
import { CountryFilters } from '../../../../app/models/Country';

type Props = {
    filter: CountryFilters;
    setFilter: (filter: CountryFilters) => void;
};

const CountryFilter = ({ filter, setFilter }: Props) => {
    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({ ...filter, [e.target.name]: e.target.value });
    };

    return (
        <div className="row">
            <div className="col-md-auto">
                <div className="mb-3">
                    <label className="font-size-10 mb-1" htmlFor="name">Nombre</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control form-control-sm"
                        value={filter.name ?? ''}
                        onChange={handleInput}
                    />
                </div>
            </div>
            <div className="col-md-auto">
                <div className="mb-3">
                    <label className="font-size-10 mb-1" htmlFor="phone_prefix">Prefijo</label>
                    <input
                        type="text"
                        id="phone_prefix"
                        name="phone_prefix"
                        className="form-control form-control-sm"
                        value={filter.phone_prefix ?? ''}
                        onChange={handleInput}
                    />
                </div>
            </div>
        </div>
    );
};

export default CountryFilter;
